export default {
  title: 'Tags de Atividade',
  title_modal: 'Nova tag',
  title_modal_edit: 'Editando tag',
  name: 'Nome',
  color: 'Cor',
  addNewButton: '+ Nova tag'
}
